import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import TabelaPadrao from "../../components/TabelaPadrao";
import { Tooltip } from "antd";

function AnalisePrint({ dados, ...props }) {
  const [showData, setShowData] = useState(false);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => setShowData(false),
  });

  useEffect(() => {
    if (showData === true) handlePrint();
  }, [showData]);

  function Func() {
    return (
      <div ref={componentRef} style={{ padding: 20 }}>
        {showData && <TabelaPadrao columns={columns} data={dados} />}
      </div>
    );
  }

  return (
    <Tooltip title="Imprimir">
      <PrinterOutlined onClick={() => setShowData(true)} className="icon-styled" style={{ marginRight: 10, fontSize: 30 }} />
      <div style={{ display: "none" }}>
        <Func />
      </div>
    </Tooltip>
  );
}

export default AnalisePrint;

const columns = [
  {
    Header: "EAN",
    accessor: "ean",
  },
  {
    Header: "CÓDIGO",
    accessor: "codigo",
  },
  {
    Header: "NOME",
    accessor: "nome",
  },
  {
    Header: "UN",
    accessor: "un",
  },
  {
    Header: "FAB",
    accessor: "fabricante",
  },
  {
    Header: "SETOR",
    accessor: "setor",
  },
  {
    Header: "GRUPO",
    accessor: "grupo",
  },
  {
    Header: "EMB",
    accessor: "embalagem",
    tipo: "rs",
  },
  {
    Header: "VALOR",
    accessor: "valor",
    tipo: "rs",
  },
  {
    Header: "CMV",
    accessor: "cmv",
    tipo: "int",
  },

  {
    Header: "QTD",
    accessor: "qtd",
    tipo: "int",
  },
  {
    Header: "ESTQ",
    accessor: "estoque",
    tipo: "int",
  },
  {
    Header: "ESTQMIN",
    accessor: "estoqueMin",
    tipo: "int",
  },
  {
    Header: "ESTQMAX",
    accessor: "estoqueMax",
    tipo: "int",
  },
  {
    Header: "GIRO",
    accessor: "giro",
    tipo: "rs",
  },
];
